class ComplementaryProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.classList.add('hidden');

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector(
          'complementary-products [data-container-products]',
        );

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.querySelector('[data-container-products]').innerHTML =
            recommendations.innerHTML;
          this.classList.remove('hidden');

          yotpoWidgetsContainer?.initWidgets(false);

          document.dispatchEvent(new Event('accordion:update'));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('complementary-products', ComplementaryProducts);
